import React from 'react';

const Nosotros = () => {
  return (
    <>
      
      <div style={{ padding: '2rem' }}>
        <h1>Welcome to the Nosotros Page</h1>
        <p>This is the Nosotros page content.</p>
      </div>
    </>
  );
};

export default Nosotros;
